import React, { useState, useEffect, useCallback, useMemo } from "react";
import styled from "styled-components";
import { ActionButton } from "../../../Components/ActionButton";
import InfoView from "../../../Components/InfoView";
import { TabContent } from "../../../Components/TabMenus";
import Api from "../../../Server/Api";
import { ACCESS_PERMISSIONS } from "../../../Constants/main";
import { MyPatientItem } from "../../doctor/secure/MyPatients";
import MedicalProfile from "./MedicalProfile";
import LoadingView from "../../../Components/LoadingView";

const api = new Api();

const AccessRequest = ({ id, permission_type, refresh }) => {
	const [loading, setLoading] = useState(false);

	const handleRequestAccess = async () => {
		setLoading(true);
		await api.post({
			endpoint: `/permission/${id}/request_permissions/`,
			data: { permission_type },
		});
		setLoading(false);
		refresh?.();
	};

	return (
		<InfoView
			title="Request Access"
			description="You do not have access to this patient's profile. Request access to view their profile."
		>
			<ActionButton
				text={"Request Access"}
				onClick={handleRequestAccess}
				loading={loading}
			/>
		</InfoView>
	);
};

const ViewPatientProfile = ({ id, patient, type = "MEDICAL-RECORD" }) => {
	const [loading, setLoading] = useState(true);
	const [record_type, setRecordType] = useState(type);
	const [permissions, setPermissions] = useState([]);

	const handleGetPermissions = useCallback(async () => {
		setLoading(true);
		const res = await api.get({
			endpoint: `/permission/${id}/access_permissions/`,
		});
		setPermissions(res);
		setLoading(false);
	}, [id]);

	const accessPermission = useMemo(() => {
		return permissions.find((permission) => permission?.type === record_type);
	}, [permissions, record_type]);

	useEffect(() => {
		handleGetPermissions();
	}, [handleGetPermissions, record_type]);

	const content = useMemo(() => {
		if (loading) {
			return (
				<LoadingView>
					<p>Loading patient profile...</p>
				</LoadingView>
			);
		}

		if (!accessPermission) {
			return (
				<AccessRequest
					id={id}
					permission_type={record_type}
					refresh={handleGetPermissions}
				/>
			);
		}
		if (accessPermission?.status === false) {
			return (
				<InfoView
					title="Access Request Pending"
					description="Your access request is pending. You will be notified when the patient approves your request request."
				/>
			);
		}
    if (record_type === "MEDICAL-PROFILE") {
      return <MedicalProfile id={id} />;
    }
	}, [accessPermission, handleGetPermissions, id, loading, record_type]);

	return (
    <Wrapper>
      <MyPatientItem
        {...patient}
        hideControls
      />
      <TabArea>
        <TabContent
          onChange={(e) => setRecordType(e.replace("profile-permission-", ""))}
          tabs={ACCESS_PERMISSIONS.map((permission) => ({
            id: `profile-permission-${permission}`,
            name: permission,
            content,
          }))}
        />
      </TabArea>
    </Wrapper>
	);
};

const RCViewPatientProfile = (props) => <ViewPatientProfile {...props} />;

export default RCViewPatientProfile;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const TabArea = styled.div`
  width: 100%;
`;